import React from 'react';
import withMainLayout from 'layouts/main';
import dynamic from 'next/dynamic';

// Content imports
import HeroSection from '@/content/developers/hero';

const PartnerProgramCategoriesSection = dynamic(
  import('@/content/developers/partner-program-categories'),
  {
    loading: () => null
  }
);

const SubmitPartnerApplication = dynamic(
  import('@/content/developers/submit-partner-application'),
  {
    loading: () => null
  }
);

const seoMetas = {
  title: 'Workable API & partner program | Build integrations for HR & recruiting',
  description:
    'Connect your product with Workable\'s API or join our partner program. Build integrations for recruiting, assessments, video interviews, background checks, and onboarding.',
  canonical: 'https://www.workable.com/developers'
};

const DevelopersPage = props => (
  <>
    <HeroSection />
    <PartnerProgramCategoriesSection />
    <SubmitPartnerApplication />
  </>
);

export default withMainLayout(DevelopersPage, {...seoMetas});

export {getSharedPageStaticProps as getStaticProps} from 'helpers/sharedPageStaticProps';
